import styled from 'styled-components';

//ActionSpacer adds a consistent margin between items, typically buttons

export default styled.div`
    white-space: nowrap;

    & > :not(:last-child) {
        margin-right: 0.5em;
    }
`;
